import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, Observable, Subject, shareReplay } from 'rxjs';
import { MatSnackBarComponent } from '../mat-snack-bar/mat-snack-bar.component';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogComponent } from '../mat-dialog/mat-dialog.component';
import { Client, EndApproval } from './client.service';
import * as langConfig from "../../assets/languageConfig/languageConfig.json";

@Injectable({
  providedIn: 'root'
})
export class AppService {

  public _loaderSubject = new BehaviorSubject(false);
  public companySetting$: Observable<any> | undefined;
  private siteSettingSubject = new Subject<any>();
  siteSetting$ = this.siteSettingSubject.asObservable();
  public healthCheckReport$: Observable<any> | undefined;
  public healthCheckReportWithJobs$: Observable<any> | undefined;
  public serviceQuoteDetails$: Observable<any> | undefined;
  public schedulingDetails$: Observable<any> | undefined;
  public serviceOrderDetails$: Observable<any> | undefined;
  public pdfReport$: Observable<any> | undefined;
  public SchedulingorderPdfReport$: Observable<any> | undefined;
  public quotePdfReport$: Observable<any> | undefined;
  public ServiceOrderPdfReport$: Observable<any> | undefined;
  isPDFCallInitiated: boolean = false;
  isSchedulingOrderPdfCallInitiated: boolean = false;
  isQuotePdfCallInitiated: boolean = false;
  isServiceOrderPDFCallInitiated: boolean = false;

  public getDealerMediaResponse$: Observable<any> | undefined

  private _tourGuideStepPosition = new BehaviorSubject(0);
  public tourGuideStepPosition$ = this._tourGuideStepPosition;

  private _languaTourGuide = new BehaviorSubject('component');
  public languaTourGuide$ = this._languaTourGuide

  private _navigationTourGuide = new BehaviorSubject('component');
  public navigationTourGuide$ = this._navigationTourGuide;
  languageConfiguration: any = langConfig;
  public proformaReport$: Observable<any> | undefined;
  private responseData = new BehaviorSubject<any>(null);
  responseData$ = this.responseData.asObservable();
  private pdfBase64Data = new BehaviorSubject<any>(null);
  pdfBase64Data$ = this.pdfBase64Data.asObservable();
  private serviceOrderResponseData = new BehaviorSubject<any>(null);
  serviceOrderResponseData$ = this.serviceOrderResponseData.asObservable();
  private quoteResponseData = new BehaviorSubject<any>(null);
  quoteResponseData$ = this.quoteResponseData.asObservable();
  private schedulingResponseData = new BehaviorSubject<any>(null);
  schedulingResponseData$ = this.schedulingResponseData.asObservable();

  constructor(private _snackBar: MatSnackBar, public dialog: MatDialog, public client: Client) { }
  setLoading(loading: boolean) {
    this._loaderSubject.next(loading);
  }
  handleErrorMessage(error: string | undefined) {
    switch (true) {
      case error && error.includes('Order Cancelled'):
        this.dialog.open(MatDialogComponent, {
          data: {
            type: 'orderCancelled',
          },
        });
        break;

      case error && error.includes('Order Invoiced'):
        this.dialog.open(MatDialogComponent, {
          data: {
            type: 'orderInvoiced',
          },
        });
        break;

      case error && error.includes('Session token expired'):
        this.dialog.open(MatDialogComponent, {
          data: {
            type: 'sessionExpired',
          },
        });
        break;

        case error && error.includes('This feature is currently not enabled. Please contact support for more information.'):
          this._snackBar.openFromComponent(MatSnackBarComponent,{
            data: 'The product ECN is currently not enabled in MW Admin Portal- API Adapter service. Please contact support for more information.',
            duration: 10000,
          });

        break;

default:
  if (error) {
    const shouldSuppress =
      (error.includes('No endpoint found')) ||
      error.includes('walkthroughEnabled') || // suppress this too
      error.includes('Walkthrough is not enabled') ||
      error.includes('Object of type Report with ID 0 could not be found.') ||
      error.includes('There is no Service Management Rep. Selection within the filter.')||
      error.includes('Server Error') ||
      error.includes(`Error converting value "" to type 'incadea.api.datamodel.Common.Enums.MIMEType'. Path 'DealerLogo.MIMEType', line 4, position 18.`);

    if (!shouldSuppress) {
      this._snackBar.openFromComponent(MatSnackBarComponent, {
        data: error,
        duration: 10000,
      });
    }
  }
  break;
    }
  }

  setDefaultLanguage() {
    let currentLanguage = window.localStorage.getItem("lang") || navigator.language;
    if (window.localStorage.getItem("lang") != null || this.languageConfiguration.LanguageCode.indexOf(navigator.language) !== -1) {
      window.localStorage.setItem("lang", currentLanguage);
    }
  }

  getStyleSettings(token: string) {
    if (!this.companySetting$) {
      const storedLang = window.localStorage.getItem('lang');
      let selectedLanguage = storedLang ?? 'en-US';
      this.companySetting$ = this.client.getStyleSettings(token, selectedLanguage).pipe(
        shareReplay(1)
      );

      this.companySetting$.subscribe({
        next: (settings) => {
          this.siteSettingSubject.next(settings);
        }
      });
    }
    return this.companySetting$
  }

  convertToHtml(text: string): string {
    text = text.replace(/#([^#]+)#/g, '<h2>$1</h2>');
    text = text.replace(/\*([^*]+)\*/g, '<b>$1</b>');
    text = text.replace(/_([^_]+)_/g, '<i>$1</i>');
    text = text.replace(/`([^`]+)`/g, '<code>$1</code>');
    text = text.replace(/\n/g, '***');
    return text;
  }

  getHealthCheckReport(token: string) {
    if (!this.healthCheckReport$) {
      const storedLang = window.localStorage.getItem('lang');
      let selectedLanguage = storedLang ?? 'en-US';
      this.healthCheckReport$ = this.client.healthCheckReport(token, false, selectedLanguage).pipe(
        shareReplay(1)
      );
    }
    return this.healthCheckReport$
  }

  getHealthCheckReportWithJobs(token: string) {
    if (!this.healthCheckReportWithJobs$) {
      const storedLang = window.localStorage.getItem('lang');
      let selectedLanguage = storedLang ?? 'en-US';
      this.healthCheckReportWithJobs$ = this.client.healthCheckReportWithJobs(token, false, selectedLanguage).pipe(
        shareReplay(1)
      );
    }
    return this.healthCheckReportWithJobs$
  }

  geServiceQuoteDetails(token: string) {
    if (!this.serviceQuoteDetails$) {
      this.serviceQuoteDetails$ = this.client.pageLoadQuoteDetails(token).pipe(
        shareReplay(1)
      );
    }
    return this.serviceQuoteDetails$
  }

  geSchedulingDetails(token: string) {
    if (!this.schedulingDetails$) {
      this.schedulingDetails$ = this.client.pageLoadSchedulingDetails(token).pipe(
        shareReplay(1)
      );
    }
    return this.schedulingDetails$
  }

  getServiceOrderDetails(token: string) {
    if (!this.serviceOrderDetails$) {
      this.serviceOrderDetails$ = this.client.ServiceOrderDetails(token).pipe(
        shareReplay(1)
      );
    }
    return this.serviceOrderDetails$
  }

  getDealerMediaResponse(token: string) {
    if (!this.getDealerMediaResponse$) {
      const storedLang = window.localStorage.getItem('lang');
      let selectedLanguage = storedLang ?? 'en-US';
      this.getDealerMediaResponse$ = this.client.getDealerMedia(token, selectedLanguage).pipe(
        shareReplay(1)
      );
    }
    return this.getDealerMediaResponse$
  }

  getPDFReport(token: string) {
    if (!this.pdfReport$ && !this.isPDFCallInitiated) {
      const storedLang = window.localStorage.getItem('lang');
      let selectedLanguage = storedLang ?? 'en-US';
      this.isPDFCallInitiated = true;
      this.pdfReport$ = this.client.getChecklistReport(token, selectedLanguage).pipe(
        shareReplay(1)
      );
    }
    return this.pdfReport$
  }

  getSchedulingOrderPDFReport(token: string) {
    if (!this.SchedulingorderPdfReport$ && !this.isSchedulingOrderPdfCallInitiated) {
      const storedLang = window.localStorage.getItem('lang');
      let selectedLanguage = storedLang ?? 'en-US';
      this.isSchedulingOrderPdfCallInitiated = true;
      this.SchedulingorderPdfReport$ = this.client.getSchedulingOrderPDFReport(token, selectedLanguage).pipe(
        shareReplay(1)
      );
    }
    return this.SchedulingorderPdfReport$
  }

  getQuotePDFReport(token: string) {
    if (!this.quotePdfReport$ && !this.isQuotePdfCallInitiated) {
      const storedLang = window.localStorage.getItem('lang');
      let selectedLanguage = storedLang ?? 'en-US';
      this.isQuotePdfCallInitiated = true;
      this.quotePdfReport$ = this.client.getQuoteReport(token, selectedLanguage).pipe(
        shareReplay(1)
      );
    }
    return this.quotePdfReport$
  }

  getServiceOrderPDFReport(token: string) {
    if (!this.ServiceOrderPdfReport$ && !this.isServiceOrderPDFCallInitiated) {
      const storedLang = window.localStorage.getItem('lang');
      let selectedLanguage = storedLang ?? 'en-US';
      this.isServiceOrderPDFCallInitiated = true;
      this.ServiceOrderPdfReport$ = this.client.getServiceOrderReport(token, selectedLanguage).pipe(
        shareReplay(1)
      );
    }
    return this.ServiceOrderPdfReport$
  }

  approveOrDeclineSchedulingJobs(authToken: string,companyId: string | undefined,orderId: string | undefined ,locationId: string | undefined,bodyData: EndApproval[]): Observable<any> {
    return this.client.authorizeSchedulingJob(authToken, companyId, orderId, locationId, bodyData)
  }
  
  approveOrDeclineQuoteJobs(authToken: string,companyId: string | undefined,orderId: string | undefined ,locationId: string | undefined,bodyData: EndApproval[])
  {
    return this.client.authorizeSevicequoteconsentdetails(authToken, companyId, orderId, locationId, bodyData)
  }

  tourGuideStepPosition(stepPosition: number) {
    this._tourGuideStepPosition.next(stepPosition)
  }

  languaTourGuide(stepPosition: string) {
    this._languaTourGuide.next(stepPosition)
  }

  navigationTourGuide(stepPosition: string) {
    this._navigationTourGuide.next(stepPosition)
  }

  formatDate(dateString: string) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString().slice(-2);
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedDate = `${day}.${month}.${year}, ${formattedHours}:${minutes}${ampm}`;

    return formattedDate;
  }

  getProformaReport(token: string) {
    if (!this.proformaReport$) {
      const storedLang = window.localStorage.getItem('lang');
      let selectedLanguage = storedLang ?? 'en-US';
      this.proformaReport$ = this.client.proformaReport(token, selectedLanguage).pipe(
        shareReplay(1)
      );
    }
    return this.proformaReport$
  }

  setResponseData(data: any) {
    this.responseData.next(data);
  }

  setPdfBase64Data(data: any) {
    this.pdfBase64Data.next(data)
  }
  setQuoteResponseData(data: any) {
    this.quoteResponseData.next(data);
  }

  setServiceOrderResponseData(data: any) {
    this.serviceOrderResponseData.next(data);
  }

  setSchedulingResponseData(data: any) {
    this.schedulingResponseData.next(data);
  }

  setStylesettings(data: any) {
    this.siteSettingSubject.next(data);
  }

  dealerMediaResponse(data: any) {
    this.getDealerMediaResponse$ = new BehaviorSubject(data).asObservable();
  }
}